import styled from 'styled-components'
import Typography, { FontWeights } from 'builder/styles/typography'
import Colors from 'builder/styles/colors'
import Sizes from 'builder/styles/sizes'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${Colors.Neutral100};
  ${Typography.Body}
  ${FontWeights.Regular}
  gap: ${Sizes.S};
  background-color: ${Colors.Blue10};
  padding: ${Sizes.S};
  border-radius: ${Sizes.S};

  ${Media.Phone`
    flex-direction: column;
  `}
`

export const ImgTextContainer = styled.div`
  display: flex;
  gap: ${Sizes.S};
  flex: 1;
  align-items: center;
`

export const Img = styled.img`
  width: 40px;
  height: 40px;
`

export const WrapperButton = styled.div`
  ${Media.Phone`
  width: 100%;
   & > * {
    width: 100%;
   }
 `}
`
